import(/* webpackMode: "eager" */ "/frontend/src/app/[lang]/[currency]/(chrome)/recruitment/[[...stepIndex]]/page.tsx")